// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const LastIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Last",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.42 29.52c.31.3.74.48 1.21.48.5 0 .94-.21 1.26-.54L29.51 17.3v-.08l.11-.17c.07-.09.13-.18.18-.29.03-.1.05-.21.07-.32.03-.1.05-.22.06-.33 0-.13-.03-.24-.06-.35-.01-.11-.04-.22-.07-.32-.06-.1-.12-.2-.19-.29s-.11-.17-.11-.17v-.08L17.89 2.73c-.32-.4-.81-.66-1.37-.66-.97 0-1.75.78-1.75 1.75 0 .52.23.99.59 1.31s10.47 10.99 10.47 10.99L15.36 27.11c-.29.31-.46.72-.46 1.18 0 .48.2.92.52 1.23m-12.7 0c.31.3.74.48 1.21.48.5 0 .94-.21 1.26-.54L16.81 17.3v-.08l.11-.17c.07-.09.13-.18.18-.29.04-.12.06-.24.08-.37.03-.1.05-.22.06-.33 0-.13-.03-.24-.06-.35-.01-.11-.04-.22-.07-.32-.06-.1-.12-.2-.19-.29s-.11-.17-.11-.17v-.08L5.18 2.66C4.86 2.26 4.37 2 3.81 2c-.97 0-1.75.78-1.75 1.75 0 .52.23.99.59 1.31s10.47 10.99 10.47 10.99l-10.46 11a1.743 1.743 0 0 0 .05 2.47Z"
    })
  });
};